export const selectProductOneWireColors = (state) => state.product.productOneWireColors
export const selectProductOneConnectorColor = (state) => state.product.productOneConnectorColor

export const selectProductTwoWireColors = (state) => state.product.productTwoWireColors
export const selectProductTwoConnectorColor = (state) => state.product.productTwoConnectorColor

export const selectProductThreeWireColors = (state) => state.product.productThreeWireColors
export const selectProductThreeConnectorColor = (state) => state.product.productThreeConnectorColor
